<template>
    <div>
        <section class="internal-page-banner-main col-12">
            <div class="container">
                <div class="row">
                    <div class="page-title">
                        <h1> HR Calendar
                            <div v-if="role.id <= 1" class="col-12 col-sm-12 col-md-3 col-lg-2 pull-right">
                                <v-select class=""
                                          v-model="locationId"
                                          name="locationId"
                                          id="locationData"
                                          label="text"
                                          :clearable="false"
                                          :searchable="false"
                                          :filterable="false"
                                          :options="locationArr"
                                          placeholder="Select State">
                                </v-select>
                            </div>
                            <div v-if="role.id <= 1" class="col-12 col-sm-12 col-md-3 col-lg-2 pull-right">
                                <v-select class=""
                                          v-model="roleId"
                                          name="roleId"
                                          id="roleData"
                                          label="text"
                                          :clearable="false"
                                          :searchable="false"
                                          :filterable="false"
                                          :options="roleArr"
                                          placeholder="Select Role">
                                </v-select>
                            </div>
                        </h1>
                    </div>
                </div>
            </div>
        </section>
        <!--End internal page banner section-->
        <div class="internal-page-main-section contact-page-main col-12">
            <!--bottom-contact-detail-->
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 b-25 calendar-main-section">
                        <div class="nevCalendar">
                            <button id="" class="btn btn-success pull-left" @click="previousMonth" style="margin-left: 5px; padding: 9px 12px;"><i class="fa fa-chevron-left" aria-hidden="true"></i></button>
                            <button id="" class="btn btn-success pull-left" @click="nextMonth" style="margin-left: 5px; padding: 9px 12px;"><i class="fa fa-chevron-right" aria-hidden="true"></i></button>
                        </div>
                        <button id="refresh" class="btn btn-success pull-right" style="margin-left: 5px; padding: 7px 12px;" @click="refreshEvents"><i class="fa fa-refresh" aria-hidden="true"></i></button>
                        <button id="backToCalendar" class="btn btn-success pull-right" style="margin-left: 5px; padding: 7px 12px;"><i class="fa fa-arrow-right" aria-hidden="true"></i></button>
                        <button type="button" id="openModel" class="btn btn-info btn-lg" data-toggle="modal" data-target="#myModal" style="display: none;">Open Modal</button>
                        <!--Search-->
                        <!--<form class="search-form" role="search">-->
                        <div class="btn btn-success form-group pull-right searchBtn" id="search">
                            <input v-model="searchEvents" type="text" class="form-control searchInput" placeholder="Search">
                            <!--<button type="button" class="form-control form-control-submit">Submit</button>-->
                            <span class="search-label"><i class="fa fa-search"></i></span>
                        </div>
                        <!--</form>-->
                        <!--End Search-->

                        <!--Calendar-->
                        <full-calendar id="HRcalendar" :events="events" :config="config" @event-selected="eventSelected" ref="calendar"></full-calendar>
                        <div class="clearfix"></div>
                        <!--End Calendar-->

                        <!--Event List-->
                        <div id="list" class="list-group">
                            <template v-for="(text, index) in eventList">
                                <button @click="loadEvent(text.value)" type="button" class="list-group-item list-group-item-action">{{text.text}}<span class="pull-right">{{text.start}}</span></button>
                            </template>
                        </div>
                        <!--End Event List-->
                    </div>
                </div>
            </div>
        </div>
        <!--bottom-contact-detail-->
        <!-- Modal -->
        <div class="modal fade" id="myModal" role="dialog">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title"><label>{{ selected.title }}</label></h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                            <div class="form-group">
                                <label>Description</label>
                                <p class="form-control">{{ selected.description }}</p>
                            </div>
                        </div>
                        <!--<div class="col-12 col-sm-12 col-md-6 col-lg-6">
                            <div class="form-group">
                                <label>State <span v-if="selected.location_code">({{ selected.location_code }})</span></label>
                                <p class="form-control">{{ selected.location_name }}</p>
                            </div>
                        </div>-->
                        <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                            <div class="form-group">
                                <label>Event for</label>
                                <p class="form-control">{{ selected.role_name }}</p>
                            </div>
                        </div>
                        <template v-if="selected.contact_email != ''">
                            <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                                <div class="form-group">
                                    <label>Email</label>
                                    <p class="form-control">{{ selected.contact_email }}</p>
                                </div>
                            </div>
                        </template>
                        <template v-if="selected.contact_number != ''">
                            <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                                <div class="form-group">
                                    <label>Phone</label>
                                    <p class="form-control">{{ selected.contact_number }}</p>
                                </div>
                            </div>
                        </template>
                        <div class="clearfix"></div>
                        <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                            <router-link id="link" v-bind:to="{ path:'/wellness/' + selected.wellness_id}" target="_blank"><p class="pull-left">{{ selected.wellness_title }}</p></router-link>
                        </div>
                        <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                            <p class="pull-right">{{ selected.eventdate }} {{ selected.eventtime }}</p>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                    <!--<div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                    </div>-->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from "vue";
    import {HTTP} from '../http-common';
    import vSelect from 'vue-select';
    import SessioMixin from '../mixins/sessionmixin';
    import { FullCalendar } from 'vue-full-calendar';
    import 'fullcalendar/dist/fullcalendar.css';
    var self;
    export default {
        name: 'contact',
        components: {
            'v-select': vSelect,
            'full-calendar': FullCalendar
        },
        mixins: [SessioMixin],
        data() {
            return {
                roleId: 0,
                startDate: 0,
                endData: 0,
                roleArr: [],
                locationId: 0,
                locationArr: [],
                config: {
                    /*'weekends': false,*/
                    defaultView: 'month',
                    displayEventTime: false,
                    editable: false,
                    eventLimit: true,
                    noEventsMessage: "HR Calendar Events Not Available",
                    eventClick: (event) => {
                        this.selected = event;
                        this.showModel();
                    },
                    header: {
                        /*left: 'prev,next',*/
                        left: '',
                        center: 'title',
                        right: 'month,listMonth',
                    },
                    buttonText: {
                        /*'prev': 'Previous',
                         'next': 'Next',*/
                        'month': 'Month',
                        'listMonth': 'List',
                    }
                },
                events: [],
                selected: {},
                eventList: [],
                searchEvents: '',
            }
        },
        beforeMount: function () {
            self = this;
            self.role.id = 0;
            self.checkLogin();
        },
        mounted: function () {
            self.startDate = self.$refs.calendar.fireMethod('getView').start.format();
            self.endDate = self.$refs.calendar.fireMethod('getView').end.format();

            self.MenuClose();
            self.getPermissions();
            self.loadLocations();
            self.loadRole();
            self.loadCalendarEvents();
            self.getBuildVersion();
            /*self.searchEvent();*/

//            Hide Initially
            $("#list").hide();
            $("#backToCalendar").hide();

            $("#link").click(function () {
                $('#myModal').modal('toggle');
            });

            $(document).ready(function () {
                /*$('#myModal').on('hidden.bs.modal', function (e) {
                    $("body").css("padding-right", "0px");
                });*/
                $('#search').on("click", (function (e) {
                    $(".searchBtn").addClass("sb-search-open");
                    $("#HRcalendar").hide();
                    $("#refresh").hide();
                    $(".nevCalendar").hide();
                    $("#backToCalendar").show();
                    $("#list").show();
                    e.stopPropagation();
                }));
//                $(document).on("click", function(e) {
//                    if ($(e.target).is("#search") === false && $(".form-control").val().length == 0) {
//                        $(".form-group").removeClass("sb-search-open");
//                        $("#HRcalendar").show();
//                        $("#eventList").hide();
//                    }
//                });
//                $(".form-control-submit").click(function(e){
//                    $(".form-control").each(function(){
//                        if($(".form-control").val().length == 0){
//                            e.preventDefault();
//                            $(this).css('border', '2px solid red');
//                        }
//                    })
//                })
            })

            $(document).ready(function () {
                $('#backToCalendar').on("click", (function (e) {
                    $(".searchBtn").removeClass("sb-search-open");
                    $("#HRcalendar").show();
                    $("#refresh").show();
                    $(".nevCalendar").show();
                    self.searchEvents = '';
                    $("#backToCalendar").hide();
                    $("#list").hide();
                    e.stopPropagation();
                }));
            });
        },
        watch: {
            locationId: function (locationId) {
                if ($(".nevCalendar").is(":visible")) {
                    self.loadCalendarEvents();
                } else {
                    self.searchEvent();
                }
            },
            roleId: function (roleId) {
                if ($(".nevCalendar").is(":visible")) {
                    self.loadCalendarEvents();
                } else {
                    self.searchEvent();
                }
            },
            searchEvents: function (searchEvents) {
                self.searchEvent();
            }
        },
        methods: {
            previousMonth() {
                self.$refs.calendar.fireMethod('prev');
                self.startDate = self.$refs.calendar.fireMethod('getView').start.format();
                self.endDate = self.$refs.calendar.fireMethod('getView').end.format();
                self.loadCalendarEvents();
            },
            nextMonth() {
                self.$refs.calendar.fireMethod('next');
                self.startDate = self.$refs.calendar.fireMethod('getView').start.format();
                self.endDate = self.$refs.calendar.fireMethod('getView').end.format();
                self.loadCalendarEvents();
            },
            loadEvent(id) {
                var path = window.location.pathname;
                var segments = path.split("/");
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };

                var data = {
                    id: id,
                };

                HTTP.post("getevent/" + id, data, config)
                        .then(function (response) {
                            self.selected = response.data.content[0];
                            self.showModel();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            searchEvent() {
                if (self.searchEvents.length >= 1) {
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                    };
                    var roleId = (self.roleId === null || self.roleId == '') ? 0 : self.roleId.value;
                    var locationId = (self.locationId === null || self.locationId == '') ? 0 : self.locationId.value;
                    var data = {
                        role_id: roleId,
                        location_id: locationId,
                        start_date: self.startDate,
                        end_date: self.endDate,
                        search: self.searchEvents,
                    };
                    HTTP.post("searchevent", data, config)
                            .then(function (response) {
                                self.eventList = response.data.content;
                            })
                            .catch(function (err) {
                                if (err.response.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (err.response.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("api_token");
                                        localStorage.removeItem("profile_image");
                                        self.$router.push("/login");
                                        //EventBus.$emit("logged-in", true, "", "");
                                    }
                                }
                            });
                }
            },
            refreshEvents() {
                var refresh = true;
                var addAll = {text: 'All', value: '0'};
                if (self.locationId.value != 0) {
                    self.locationId = addAll;
                    refresh = false;
                }
                var addAll = {text: 'All', value: '0'};
                if (self.roleId.value != 0) {
                    self.roleId = addAll;
                    refresh = false;
                }
                if (refresh) {
                    self.loadCalendarEvents();
                }
            },
            showModel() {
                //console.log(self.selected.id);
                $('#openModel').click();
            },
            eventSelected(event) {
                self.selected = event;
                //console.log(self.selected);
            },
            loadLocations() {
                HTTP.post("getlocation")
                        .then(function (response) {
                            self.locationArr = [];
                            /*var addAll = {text: 'All', value: '-1'};
                             self.locationArr.push(addAll);*/
                            $.each(response.data.content, function (i) {
                                /*if (response.data.content[i].value != 0) {*/
                                self.locationArr.push(response.data.content[i]);
                                /*}*/
                            });
                            self.locationId = {text: response.data.content[0].text, value: response.data.content[0].value};
                        })

                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                            }
                        });
            },
            loadRole() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                HTTP.post("getroles", '', config)
                        .then(function (response) {
                            self.roleArr = [];
                            var addAll = {text: 'All', value: '0'};
                            //self.roleArr.push(addAll);
                            $.each(response.data.content, function (i) {
                                self.roleArr.push(response.data.content[i]);
                            });
                            self.roleId = addAll;
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                            }
                        });
            },
            loadCalendarEvents() {
                self.selected = {};
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                var roleId = (self.roleId === null || self.roleId == '') ? 0 : self.roleId.value;
                var locationId = (self.locationId === null || self.locationId == '') ? 0 : self.locationId.value;
                var fields = {
                    role_id: roleId,
                    location_id: locationId,
                    start_date: self.startDate,
                    end_date: self.endDate,
                };
                HTTP.post("getevents", fields, config)
                        .then(function (response) {
                            self.events = response.data.content;
                            self.$refs.calendar.$emit('refetch-events');
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/hrCalendar.vue